import { render } from "./SpotCombinationPatternContainer.vue?vue&type=template&id=42558e70&ts=true"
import script from "./SpotCombinationPatternContainer.vue?vue&type=script&lang=ts"
export * from "./SpotCombinationPatternContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__